/*用户管理 */
import { $http, buildHeaders } from "./index";

//获取用户列表
export const admin_list = (params) => {
  return $http.get("/admin/Admin/index", { params });
};

//获取用户详情
export const admin_detail = (id) => {
  return $http.get("/admin/Admin/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取登录用户信息
export const admin_auth = () => {
  return $http.get("/admin/Admin/getAuth");
};

//获取客户下拉数据
export const admin_select = () => {
  return $http.get("/admin/Admin/index", {
    params: { limit: 0, sort_field: "name", status: 1 },
  });
};

//添加用户
export const admin_add = (data) => {
  return $http.post("/admin/Admin/add", data, {
    headers: buildHeaders(3),
  });
};

//修改用户
export const admin_edit = (data) => {
  return $http.post("/admin/Admin/edit", data, {
    headers: buildHeaders(3),
  });
};

//用户启停
export const admin_qt = (data) => {
  return $http.post("/admin/Admin/updateStatus", data, {
    headers: buildHeaders(3),
  });
};

//重置密码
export const admin_resetpass = (data) => {
  return $http.post("/admin/Admin/resetPassword", data, {
    headers: buildHeaders(3),
  });
};

//删除用户
export const admin_delete = (id) => {
  return $http.post(
    "/admin/Admin/del",
    { id },
    {
      headers: buildHeaders(3),
    }
  );
};
